
import HTMLRenderer from './../../zviz2/zviz/renderers/html';

import Group from './../../zviz2/zviz/components/group';

import Tooltip from './../../components/elements/tooltip';
import {extend, cloneObject} from './../../zviz2/zviz/functions';
import state from './../../zviz2/zviz/state';
import global from './../../zviz2/zviz/global';

let scripts = document.getElementsByTagName('script');
let scriptNode = document.currentScript || scripts[scripts.length - 1];

class Component{

    constructor(settings={}){
        
        settings = extend(settings, {
            container: null,
        });

        this.objects = [];

        let Blueprint = extend({
            children: [
                cloneObject(Tooltip)
            ],
            properties: {
                style: { 
                    position: 'relative'
                 }
            },
            listeners: [
            ]
        }, Group);

        let container = settings.container;
        if(container == null){
            container = scriptNode.parentNode;
        }else if(typeof container == 'string'){
            container = document.getElementById(container);
        }

        let renderer = new HTMLRenderer();
        renderer.setCanvas(container);
        renderer.start(Blueprint);

        this.objects.push(renderer);

    }

    remove(){
        for(let o of this.objects){
            if(! (o instanceof Function)){
                o.remove();
            }
        }
        delete this.objects;
    }

}    

export default Component;

